import React, { useState, useEffect } from 'react';
import { db, auth } from '../firebase';
import { collection, query, where, orderBy, onSnapshot, doc, updateDoc } from 'firebase/firestore';
import './Mailbox.css';

const Mailbox = ({ onBack }) => { // Add onBack prop
  const [letters, setLetters] = useState([]);
  const [selectedLetter, setSelectedLetter] = useState(null);

  useEffect(() => {
    if (!auth.currentUser) return;
    
    const q = query(
      collection(db, 'letters'),
      where('to', '==', auth.currentUser.uid),
      orderBy('createdAt', 'desc')
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const lettersData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setLetters(lettersData);
    });

    return () => unsubscribe();
  }, []);

  const handleSelectLetter = async (letter) => {
    setSelectedLetter(letter);
    if (!letter.isRead) {
      const letterRef = doc(db, 'letters', letter.id);
      await updateDoc(letterRef, {
        isRead: true,
      });
    }
  };

  return (
    <div className="mailbox-container">
      <link href="https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400..700&display=swap" rel="stylesheet" />
      <div className="letter-list">
        <div className="mailbox-header">
          <button onClick={onBack} className="back-button">←</button>
          <h2>Mailbox</h2>
        </div>
        {letters.map(letter => (
          <div
            key={letter.id}
            className={`letter-item ${!letter.isRead ? 'unread' : ''} ${selectedLetter?.id === letter.id ? 'selected' : ''}`}
            onClick={() => handleSelectLetter(letter)}
          >
            <p className="from-name">From: {letter.fromName || 'Anonymous'}</p>
            <p className="received-date">Received: {new Date(letter.createdAt.seconds * 1000).toLocaleString()}</p>
          </div>
        ))}
      </div>
      <div className="letter-view">
        {selectedLetter ? (
          <div className="letter-content">
            <h3>From: {selectedLetter.fromName || 'Anonymous'}</h3>
            <p className="letter-message">{selectedLetter.message}</p>
          </div>
        ) : (
          <p className="placeholder-text">Select a letter to read.</p>
        )}
      </div>
    </div>
  );
};

export default Mailbox;
